import { render, staticRenderFns } from "./organizations-by-region-widget.vue?vue&type=template&id=172651d6&scoped=true&"
import script from "./organizations-by-region-widget.vue?vue&type=script&lang=js&"
export * from "./organizations-by-region-widget.vue?vue&type=script&lang=js&"
import style0 from "./organizations-by-region-widget.vue?vue&type=style&index=0&id=172651d6&prod&scoped=true&lang=css&"
import style1 from "./organizations-by-region-widget.vue?vue&type=style&index=1&id=172651d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172651d6",
  null
  
)

export default component.exports